









































import { Component, Mixins, Prop } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import { PortalAccount } from "@/types/mypage";
import Staff from "./kaedokiofficelist/Staff.vue";

@Component({ components: { Staff } })
export default class extends Mixins(AxiosMixin) {
  /** カエドキ一覧 */
  @Prop({ default: () => [] }) private kaedoki_recruiters!: PortalAccount[];

  /** カエドキ求人一覧 */
  @Prop({ default: () => [] }) private kaedoki_recruitees!: PortalAccount[];
}
